// extracted by mini-css-extract-plugin
export var container = "ExplicitEditor-module--container--ySziF";
export var prevBtn = "ExplicitEditor-module--prev-btn--1YqhB";
export var infoBtn = "ExplicitEditor-module--info-btn--3c1De";
export var result = "ExplicitEditor-module--result--36WaP";
export var input = "ExplicitEditor-module--input--1r9T0";
export var output = "ExplicitEditor-module--output--2k8bG";